/**
 * Product photos for the homepage category circles.
 *
 * The client supplies these. To add one: drop the file in
 * `public/static/images/categories/` and add its category id below. A
 * category with no entry falls back to the icon the topbar menu uses, so the
 * row never shows a broken image while we are waiting for artwork.
 *
 * Square images work best — they are cropped to a circle. Aim for at least
 * 400×400 so they stay sharp on a retina desktop.
 */
export const CATEGORY_IMAGES = {
  klar: '/static/images/categories/klar.jpg',
  sko: '/static/images/categories/sko.jpg',
  acc: '/static/images/categories/acc.jpg',
};

/** The photo for a category, or null when none has been supplied yet. */
export const categoryImage = categoryId => CATEGORY_IMAGES[categoryId] || null;
